/* Stickers Souq — the sheet builder's motion, in index8's style (nd-motion6.js does the same for the
   home page's mini builder). It never changes what sticker-sheet-builder.js does: a capture listener
   notes where everything is just before the builder reacts to a tap, a bubble listener animates the
   difference just after.
     · a sticker flies from its tile onto its space on the sheet — on phones, when the sheet is out of
       view, into the bar at the bottom; one taken off peels away; the rest glide to their new places;
       a new size for the sheet (S · M · L) makes them grow or shrink into the new grid
     · counters pop, a full sheet gets confetti, a tap on a full sheet shakes it
     · new tiles pop in (not while typing a search)
     · "Add to cart": the sheet flies into the cart in the header (the builder then opens the cart)
   Only with html.js — the page leaves it off when the device asks for reduced motion. */
(function () {
  "use strict";
  var root = document.querySelector("[data-ssb]");
  if (!root || !document.documentElement.classList.contains("js") || !Element.prototype.animate) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return (r || root).querySelectorAll(s); };
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var POP = "cubic-bezier(.34,1.56,.64,1)";
  var COLORS = ["#fd8484", "#e4c98a", "#7fb3c8", "#8fb59b", "#8e93c4", "#d98e86", "#191919"];
  var paper = $("[data-paper]"), grid = $("[data-grid]");
  var cartIcon = document.querySelector("[data-cart-icon]");
  var snap = null, inFlight = {}, typing = false;

  function bump(el) { if (el) el.animate([{ scale: 1 }, { scale: 1.28 }, { scale: 1 }], { duration: 420, easing: POP }); }
  function shake(el) {
    if (el) el.animate([{ translate: "0 0" }, { translate: "-7px 0" }, { translate: "6px 0" }, { translate: "-4px 0" }, { translate: "0 0" }], { duration: 420 });
  }
  function centre(r) { return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function onScreen(r) { return r.width > 0 && r.bottom > 0 && r.top < innerHeight; }
  function pinned() { return root.classList.contains("is-compact"); }
  function sticker(src, r) {                       // a copy of a sticker, fixed over the page
    var c = document.createElement("img");
    c.src = src; c.alt = ""; c.className = "v6-fly";
    c.style.left = r.left + "px"; c.style.top = r.top + "px"; c.style.width = r.width + "px"; c.style.height = r.height + "px";
    document.body.appendChild(c);
    return c;
  }

  /* ---- what is on the sheet right now ---- */
  function cells() { return $$(".ssb-cell", paper); }
  function state() {
    var pos = {};
    each(cells(), function (c) { pos[c.getAttribute("data-uid")] = c.querySelector("img").getBoundingClientRect(); });
    return { pos: pos, n: cells().length, cap: $$(".ssb-cell, .ssb-slot", paper).length, total: $("[data-total]").textContent };
  }

  /* just before the builder reacts */
  root.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    snap = state();
    snap.tile = null;
    var tile = t.closest(".ssb-tile");
    if (tile) {
      var ti = tile.querySelector("img");
      snap.tile = { el: tile, rect: ti.getBoundingClientRect(), url: ti.currentSrc || ti.getAttribute("src"),
                    count: +tile.querySelector(".ssb-n").textContent || 0 };
      tile.animate([{ scale: 1 }, { scale: .86 }, { scale: 1.06 }, { scale: 1 }], { duration: 380, easing: "ease-out" });
    }
    // a tap on a sticker on the sheet opens its menu; it peels away when "Remove" is chosen there
    var open = t.closest("[data-menu-remove]") && paper.querySelector(".ssb-cell.is-open");
    if (open) peel(open.querySelector("img"), 0);
    if (t.closest("[data-clear]")) each(cells(), function (c, k) { peel(c.querySelector("img"), Math.min(k, 20) * 35); });
    if (t.closest(".ssb-chip")) typing = false;
    var add = t.closest("[data-add]");
    if (add && !add.disabled) toCart();
  }, true);

  /* just after: animate what changed */
  root.addEventListener("click", function () {
    if (!snap) return;
    var s = snap, now = state();
    snap = null;
    if (root.classList.contains("is-big")) return;   // big-sticker mode: a tap opens the size panel, nothing lands on the sheet
    // stickers already on the sheet glide to their new spaces (after one comes off, A4 ↔ A3, or a new size)
    each(cells(), function (c) {
      var uid = c.getAttribute("data-uid"), img = c.querySelector("img"), old = s.pos[uid];
      if (inFlight[uid]) { img.style.opacity = "0"; return; }
      if (!old) return;
      var r = img.getBoundingClientRect(), a = centre(old), b = centre(r);
      var dx = a.x - b.x, dy = a.y - b.y, sc = old.width / r.width;
      if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sc - 1) < .01) return;
      img.animate([{ transform: "translate(" + dx + "px," + dy + "px) scale(" + sc + ")" }, { transform: "none" }],
        { duration: 480, easing: "cubic-bezier(.34,1.3,.64,1)" });
    });
    if (s.tile) {
      var added = null;
      each(cells(), function (c) { if (!s.pos[c.getAttribute("data-uid")]) added = c; });
      if (added) fly(s.tile, added);
      else if (now.n === s.n) shake(onScreen(paper.getBoundingClientRect()) ? paper : $(".ssb-buy"));   // the sheet is full
      var badge = s.tile.el.querySelector(".ssb-n");
      if (+badge.textContent > s.tile.count) bump(badge);
    }
    if (now.total !== s.total) bump($("[data-total]"));
    if (now.n !== s.n || now.cap !== s.cap) { bump($("[data-fill-label]")); bump($("[data-fill-mini]")); }
    if (now.cap !== s.cap) paper.animate([{ scale: .95 }, { scale: 1.02 }, { scale: 1 }], { duration: 480, easing: "ease-out" });
    // just filled the sheet: celebrate
    if (now.cap && now.n === now.cap && now.n > s.n) {
      setTimeout(function () {
        confetti(onScreen(paper.getBoundingClientRect()) ? paper : $(".ssb-buy"));
        bump($("[data-fill-left]"));
      }, s.tile ? 600 : 0);
    }
  });

  /* a sticker flies from its tile to its space, lifting and turning on the way */
  function fly(src, cell) {
    var uid = cell.getAttribute("data-uid"), img = cell.querySelector("img"), to = img.getBoundingClientRect();
    if (!onScreen(to)) {
      if (pinned()) toBar(src);
      return;
    }
    var c = sticker(src.url, src.rect);
    inFlight[uid] = true;
    img.style.opacity = "0";
    var a = centre(src.rect), b = centre(to);
    var dx = b.x - a.x, dy = b.y - a.y, sc = Math.min(to.width / src.rect.width, to.height / src.rect.height);
    var lift = Math.min(150, 70 + Math.abs(dx) * .12);
    c.animate([
      { transform: "translate(0,0) scale(1) rotate(0deg)" },
      { transform: "translate(" + dx * .5 + "px," + (dy * .5 - lift) + "px) scale(" + ((1 + sc) / 2 * 1.2) + ") rotate(-14deg)", offset: .5 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(" + sc + ") rotate(0deg)" }
    ], { duration: 650, easing: "cubic-bezier(.45,.05,.35,1)" }).onfinish = function () {
      c.remove();
      delete inFlight[uid];
      var el = paper.querySelector('.ssb-cell[data-uid="' + uid + '"] img');
      if (el) { el.style.opacity = ""; el.animate([{ scale: 1.3 }, { scale: .9 }, { scale: 1 }], { duration: 320, easing: "ease-out" }); }
    };
  }

  /* phones: the sheet is up the page, so the sticker drops into the bar at the bottom instead */
  function toBar(src) {
    var m = $("[data-fill-mini]").getBoundingClientRect();
    var c = sticker(src.url, src.rect), a = centre(src.rect);
    var dx = m.left + 16 - a.x, dy = m.top + m.height / 2 - a.y, sc = 32 / src.rect.width;
    c.animate([
      { transform: "translate(0,0) scale(1) rotate(0deg)", opacity: 1 },
      { transform: "translate(" + dx * .5 + "px," + (dy * .5 - 90) + "px) scale(" + (1 + sc) / 2 + ") rotate(-14deg)", opacity: 1, offset: .55 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(" + sc + ") rotate(0deg)", opacity: .3 }
    ], { duration: 650, easing: "cubic-bezier(.45,.05,.35,1)" }).onfinish = function () {
      c.remove();
      bump($("[data-fill-mini]"));
      bump($("[data-total]"));
    };
  }

  /* taking a sticker off: it peels up and falls away (Clear: one after another, each waiting in place) */
  function peel(img, delay) {
    if (!img) return;
    var r = img.getBoundingClientRect();
    if (!onScreen(r)) return;
    var c = sticker(img.getAttribute("src"), r);
    c.animate([
      { transform: "none", opacity: 1 },
      { transform: "translate(10px,-26px) rotate(18deg) scale(1.1)", opacity: 1, offset: .35 },
      { transform: "translate(46px,46px) rotate(42deg) scale(.4)", opacity: 0 }
    ], { duration: 540, delay: delay, easing: "ease-in", fill: "backwards" }).onfinish = function () { c.remove(); };
  }

  function confetti(anchor) {
    if (!anchor) return;
    var r = anchor.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + Math.min(r.height * .35, 200);
    for (var k = 0; k < 30; k++) {
      var p = document.createElement("i"), w = 6 + Math.random() * 7, h = 8 + Math.random() * 9;
      p.className = "v6-confetti";
      p.style.left = (x - w / 2) + "px"; p.style.top = (y - h / 2) + "px";
      p.style.width = w + "px"; p.style.height = h + "px"; p.style.background = COLORS[k % COLORS.length];
      document.body.appendChild(p);
      var ang = Math.random() * Math.PI * 2, dist = 90 + Math.random() * 170;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 90, rot = (Math.random() - .5) * 720;
      p.animate([
        { transform: "translate(0,0) rotate(0deg)", opacity: 1 },
        { transform: "translate(" + dx + "px," + dy + "px) rotate(" + rot / 2 + "deg)", opacity: 1, offset: .55 },
        { transform: "translate(" + dx * 1.2 + "px," + (dy + 170) + "px) rotate(" + rot + "deg)", opacity: 0 }
      ], { duration: 1200 + Math.random() * 500, easing: "cubic-bezier(.2,.6,.4,1)" }).onfinish = (function (el) {
        return function () { el.remove(); };
      })(p);
    }
  }

  /* "Add to cart": a copy of the sheet flies into the cart in the header */
  function toCart() {
    if (!cartIcon) return;
    var r = paper.getBoundingClientRect(), to = cartIcon.getBoundingClientRect();
    if (!onScreen(r)) { bump(cartIcon); return; }
    var c = paper.cloneNode(true);
    c.removeAttribute("data-paper");
    c.setAttribute("aria-hidden", "true");
    c.style.cssText = "position:fixed;margin:0;z-index:90;pointer-events:none;left:" + r.left + "px;top:" + r.top + "px;width:" + r.width + "px;height:" + r.height + "px";
    document.body.appendChild(c);
    var a = centre(r), b = centre(to);
    var dx = b.x - a.x, dy = b.y - a.y, sc = Math.max(.05, to.width / r.width);
    c.animate([
      { transform: "translate(0,0) scale(1) rotate(0deg)", opacity: 1 },
      { transform: "translate(" + dx * .4 + "px," + (dy * .4 - 60) + "px) scale(.55) rotate(-8deg)", opacity: 1, offset: .45 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(" + sc + ") rotate(6deg)", opacity: .2 }
    ], { duration: 800, easing: "cubic-bezier(.45,.05,.35,1)", fill: "forwards" }).onfinish = function () { c.remove(); bump(cartIcon); };
  }

  /* new tiles pop in, a few at a time — on load, on a new section or "Show more", not while typing */
  var q = $("[data-q]");
  if (q) q.addEventListener("input", function () { typing = true; });
  function popIn(items, base) {
    each(items, function (el, k) {
      el.style.setProperty("--i", Math.min(k, 18));
      el.style.animationDelay = "calc(" + base + "s + var(--i) * 32ms)";
      el.classList.add("ssb-pop");
    });
  }
  popIn($$(".ssb-item", grid), .5);                // the first tiles, as the library rises in
  new MutationObserver(function (list) {
    if (typing) return;
    var fresh = [];
    list.forEach(function (m) { each(m.addedNodes, function (n) { if (n.nodeType === 1 && n.classList.contains("ssb-item")) fresh.push(n); }); });
    popIn(fresh, 0);
  }).observe(grid, { childList: true });
})();
